import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { PasswordFormComponent } from "@shared/components/password-form/password-form.component";
import { EMAIL, RESET_CODE } from "@shared/constants/route-variables.constants";
import { AUTHENTIFICATION_FORTE, CONNEXION, PAGE_NON_TROUVEE } from "@shared/constants/route.constants";
import { AuthenticationService } from "@shared/services/authentication.service";
import { MembersService } from "@shared/services/members.service";
import { switchMap } from "rxjs";
import { LinkExpirationDialogComponent } from "./link-expiration-dialog/link-expiration-dialog.component";
import { PopupPasswordTemplateComponent } from "@shared/components/popup-password-template/popup-password-template.component";

@Component({
  selector: "app-password-reset",
  standalone: true,
  imports: [
    CommonModule,
    PasswordFormComponent,
    LinkExpirationDialogComponent,
    TranslateModule,
    PopupPasswordTemplateComponent,
  ],
  templateUrl: "./password-reset.component.html",
})
export class PasswordResetComponent implements OnInit {
  showPasswordInit = false;
  email: string | undefined;
  resetCode: string | undefined;
  isDialogVisible = false;

  constructor(
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private router: Router,
    private memberService: MembersService
  ) {}

  ngOnInit(): void {
    this.route.queryParamMap.subscribe(params => {
      this.email = params.get(EMAIL)!;
      this.resetCode = params.get(RESET_CODE)!;
      if (!this.email || !this.resetCode) {
        this.router.navigate([PAGE_NON_TROUVEE]);
      }
      this.showPasswordInit = true;
    });
  }

  onPasswordSubmit(newPassword: string) {
    if (this.email && this.resetCode) {
      this.authenticationService
        .setPassword(this.email, this.resetCode, newPassword)
        .pipe(switchMap(() => this.memberService.updateEnrollmentStatus(this.email!, newPassword, true)))
        .subscribe({
          next: () => {
            localStorage.setItem("EMAIL", this.email!);
            this.authenticationService.sendToken(this.email!).subscribe({
              next: () => {
                this.authenticationService.sharedEmail(this.email!);
                this.authenticationService.sharedPassword(newPassword);
                this.router.navigate([AUTHENTIFICATION_FORTE]);
              },
            });
          },
          error: () => {
            this.showDialog();
          },
        });
    }
  }

  showDialog(): void {
    this.isDialogVisible = true;
  }

  handleDialogClose(): void {
    this.router.navigate([CONNEXION]);
  }
}
